import { Button, Flex, FlexProps, Text } from '@chakra-ui/react'

const bgColorRoot = '#F9F9FF'
const bgColorChip = '#E9F5FF'

function Chip({
  label,
  isSelected,
  select
}: {
  label: string
  isSelected: boolean
  select: () => void
}) {
  return (
    <Button
      colorScheme={isSelected ? 'blue' : 'gray'}
      bgColor={isSelected ? bgColorChip : 'transparent'}
      isDisabled={isSelected}
      _disabled={{
        cursor: 'not-allowed'
      }}
      _hover={{
        bgColor: bgColorChip
      }}
      borderRadius={'full'}
      px={'2'}
      py={'2'}
      flex={'1'}
      h={'7'}
      w={'full'}
      minW={'max-content'}
      onClick={select}
    >
      <Text
        _firstLetter={{ textTransform: 'uppercase' }}
        fontSize={'0.875rem'}
        fontWeight={'500'}
        color={isSelected ? 'custom.blue.darker' : 'custom.gray.400'}
      >
        {label}
      </Text>
    </Button>
  )
}

export function PeriodSelector<Value extends string = string>({
  options,
  value,
  onChange,
  ...props
}: {
  options: {
    label: string
    value: Value
  }[]
  value: Value
  onChange: (value: Value) => void
} & Omit<FlexProps, 'onChange'>) {
  return (
    <Flex
      gap={'4'}
      bgColor={bgColorRoot}
      borderRadius={'full'}
      py={'1.5'}
      px={'3'}
      w={'full'}
      {...props}
    >
      {options.map((opt) => {
        return (
          <Chip
            key={opt.label}
            label={opt.label}
            isSelected={opt.value === value}
            select={() => onChange(opt.value)}
          />
        )
      })}
    </Flex>
  )
}
